var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apps-container"},[_c('div',{staticClass:"apps-inner"},[_c('div',{staticClass:"category"},[_c('div',[_c('span',{staticClass:"active",on:{"click":_vm.selectCategory}},[_vm._v("全部")]),_vm._l((_vm.categoryList),function(item){return _c('span',{key:item.id,on:{"click":function($event){return _vm.selectCategory($event, item)}}},[_vm._v(" "+_vm._s(item.name))])})],2)]),_vm._l((_vm.appList),function(ref){
var id = ref.id;
var name = ref.name;
var children = ref.children;
return _c('div',{key:id,staticClass:"app",attrs:{"data-title":name}},_vm._l((children),function(ref){
var id = ref.id;
var name = ref.name;
var customIcon = ref.customIcon;
var sourceType = ref.sourceType;
var url = ref.url;
return _c('div',{key:id,on:{"click":function($event){return _vm.clickApp(sourceType, id, url)}}},[_c('img',{attrs:{"src":_vm.baseUrl + customIcon,"alt":""}}),_c('span',[_vm._v(_vm._s(name))])])}),0)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }